import { render, staticRenderFns } from "./NewsLine.vue?vue&type=template&id=db9c6342"
import script from "./NewsLine.vue?vue&type=script&lang=js"
export * from "./NewsLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports